import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BookingReferenceCard = ({ confirmationNumber }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator?.clipboard?.writeText(confirmationNumber);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-6 md:p-8 border border-primary/20 shadow-sm animate-fade-in">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
          <Icon name="Hash" size={24} color="white" />
        </div>
        <h2 className="font-heading font-semibold text-2xl text-foreground">
          Booking Reference
        </h2>
      </div>

      <div className="bg-card rounded-lg p-6 border border-border">
        <p className="text-sm text-muted-foreground font-caption mb-2">
          Your confirmation number
        </p>
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <p className="font-mono font-bold text-2xl md:text-3xl text-primary tracking-wider">
            {confirmationNumber}
          </p>
          <Button
            onClick={handleCopy}
            variant={copied ? "success" : "outline"}
            size="sm"
            iconName={copied ? "Check" : "Copy"}
          >
            {copied ? 'Copied!' : 'Copy'}
          </Button>
        </div>
      </div>

      <div className="mt-4 p-4 bg-card/50 rounded-lg border border-border">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
          <p className="text-xs md:text-sm text-muted-foreground font-caption leading-relaxed">
            Please save this reference number. You'll need it to modify or cancel your appointment.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookingReferenceCard;